import {IndexRedirect, Route} from 'react-router';
import CoachSummaryDashboard from 'components/dashboard/coach/CoachSummaryDashboard';
import CoachingPlansWidgetContainer, {
  CoachCoachingPlansWidgetContainer,
} from 'components/dashboard/CoachingPlansWidgetContainer';
import {
  CoachCoachingEffectivenessPage,
  ManagerCoachingEffectivenessPage,
} from 'components/dashboard/manager/ManagerCoachingEffectiveness';
import {
  RepCallActivityContainer,
  RepCallsContainer,
  RepCoachingFromManagerContainer,
  RepCoachingFromOthersContainer,
  RepCoachingPlansContainer,
  RepOtherReviewContainer,
  RepSelfReviewContainer,
} from 'components/dashboard/rep/RepProfilePageContainer';
import {DashKpiPage} from '$pages/$rep-profile/kpi/DashKpiPage';
import React from 'react';
import AdminSummaryDashboard from 'components/dashboard/admin/AdminSummaryDashboard';
import AdminDashCoachingActivity from 'components/dashboard/admin/AdminDashCoachingActivity';
import AdminDashCoachingMeetingsContainer from 'components/dashboard/admin/admin-coaching-meetings/AdminDashCoachingMeetingsContainer';
import AdminDashCoachingWrapper from 'components/dashboard/admin/AdminDashCoachingWrapper';
import AdminDashTeamSkills from 'components/dashboard/admin/AdminDashTeamSkills';
import DashboardRollup from 'components/dashboard/rollups/DashboardRollup';
import {
  adminCallActivity,
  callActivity,
  coachMetrics,
  managerCoaching,
  managerMetrics,
  otherCoaching,
  peerCoaching,
  peerMetrics,
  selfReview,
} from 'components/dashboard/rollups/rollupTypes';
import AdminTopicRollup from 'components/dashboard/admin/AdminTopicRollup';
import ManagerSummaryDashboard from 'components/dashboard/ManagerSummaryDashboard';
import ManagerTodaysConversations from 'components/dashboard/ManagerTodaysConversations';
import ManagerCallMetrics from 'components/dashboard/ManagerCallMetrics';
import ManagerRepSkills from 'components/dashboard/manager/ManagerRepSkills';
import ManagerTopicRollup from 'components/dashboard/manager/ManagerTopicRollup';
import {dashV2Path} from 'components/StatsPage2.utils';
import {dashboardRedirectOnChange} from 'components/routes/Router.utils';
import StatsPage2 from 'components/StatsPage2';
import DashboardDateRangeActions from 'actions/dashboard/DasbhoardDateRangeActions';

const coachDash = (
  <Route path="coach/:coachId">
    <IndexRedirect to="summary" />
    <Route path="summary" component={CoachSummaryDashboard} />
    <Route path="coaching-plans" component={CoachCoachingPlansWidgetContainer} />
    <Route path="coaching-effectiveness" component={CoachCoachingEffectivenessPage} />
    <Route path="coaching-plans-for-you" component={RepCoachingPlansContainer} />
    <Route path="call-activity" component={RepCallActivityContainer} />
    <Route path="self-review" component={RepSelfReviewContainer} />
    <Route path="other-review" component={RepOtherReviewContainer} />
    <Route path="coaching-from-manager" component={RepCoachingFromManagerContainer} />
    <Route path="coaching-from-others" component={RepCoachingFromOthersContainer} />
    <Route path="calls" component={RepCallsContainer} />
    <Route path="kpi" component={DashKpiPage} />
  </Route>
);

const managerDash = (
  <Route path="manager/:managerId">
    <IndexRedirect to="summary" />
    <Route path="summary" component={ManagerSummaryDashboard} />
    {/* Call Activity */}
    <Route
      path="rep-activity"
      component={props => <DashboardRollup {...props} config={callActivity} />}
    />
    <Route path="todays-conversations" component={ManagerTodaysConversations} />
    <Route path="call-metrics" component={ManagerCallMetrics} />
    {/* Coaching */}
    <Route path="coaching-effectiveness" component={ManagerCoachingEffectivenessPage} />
    <Route path="rep-skills" component={ManagerRepSkills} />
    <Route path="coaching-plans" component={CoachingPlansWidgetContainer} />
    <Route
      path="your-coaching"
      component={props => <DashboardRollup {...props} config={managerCoaching} />}
    />
    <Route
      path="self-review"
      component={props => <DashboardRollup {...props} config={selfReview} />}
    />
    <Route
      path="peer-coaching"
      component={props => <DashboardRollup {...props} config={peerCoaching} />}
    />
    <Route
      path="other-coaching"
      component={props => <DashboardRollup {...props} config={otherCoaching} />}
    />
    <Route
      path="topics"
      component={ManagerTopicRollup}
      onEnter={DashboardDateRangeActions.enterTopicRollup}
      onLeave={DashboardDateRangeActions.leaveTopicRollup}
    />
    <Route path="kpi" component={DashKpiPage} />
    {coachDash}
  </Route>
);

const adminDash = (
  <Route path="admin/:adminId">
    <IndexRedirect to="summary" />
    <Route path="summary" component={AdminSummaryDashboard} />
    {/* Coaching */}
    <Route path="coaching-activity" component={AdminDashCoachingActivity} />
    <Route path="coaching-meetings" component={AdminDashCoachingMeetingsContainer} />
    <Route path="coaching-plans" component={AdminDashCoachingWrapper} />
    <Route path="team-skills" component={AdminDashTeamSkills} />
    <Route
      path="manager-coaching"
      component={props => <DashboardRollup {...props} config={managerMetrics} />}
    />
    <Route
      path="coach-coaching"
      component={props => <DashboardRollup {...props} config={coachMetrics} />}
    />
    <Route
      path="other-coaching"
      component={props => <DashboardRollup {...props} config={peerMetrics} />}
    />
    <Route
      path="activity"
      component={props => <DashboardRollup {...props} config={adminCallActivity} />}
    />
    {/* Topics */}
    <Route
      path="topics"
      component={AdminTopicRollup}
      onEnter={DashboardDateRangeActions.enterTopicRollup}
      onLeave={DashboardDateRangeActions.leaveTopicRollup}
    />
    <Route path="kpi" component={DashKpiPage} />
    {managerDash}
    {coachDash}
  </Route>
);

export const dashV2Route = (
  <Route
    path={dashV2Path}
    onEnter={(nextState, replace) => dashboardRedirectOnChange(null, nextState, replace)}
    onChange={dashboardRedirectOnChange}
    component={StatsPage2}>
    {adminDash}
    {managerDash}
    {coachDash}
  </Route>
);
